import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterTag_template} from "./filterTag_template";
import { emaki_brand } from "../../utils/types/emaki_brand";
import { EditedSpec, Spec } from "../../utils/types/tag";
import { SPEC_DATA_TYPES, isSpecTypeIdWithRestrictions } from "../../utils/consts/tag_spec_type";
import { DragAndDropHandler } from "../../utils/DragAndDropHandler";

declare var ko: any;

interface Option {id: number; name: string;}
export class tagTypFieldEdit_template extends vnTemplate {

    public tagPickerSourceFilterTagType: filterAutocomplete_template;
    public tagSourcePickerTagFilter: filterTag_template;
    public editSpecificationTooltip: infoButton_template;
    public validationsList: validationsList_template;
    private editSpecificationTooltipContent: string;

    protected getTemplateHtml(): string {

        return /*html*/`

                <div data-bind="css: { 'is-visible': isVisible() }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form" style="width:50rem;">
                            <div class="form-header">
                                <h3 class="form-title" data-bind="text: popupTitle"></h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCancelSaveSpecification }"></button>
                            </div>
                            <div class="form-body overflow-clear">
                                <div class="form-group row">${this.validationsList.getHtmlBuild()}</div>

                                <div class="form-group row">
                                    <label class="form-label">Label</label>
                                    <input type="text" class="input-text"  data-bind="value: label, enable: !fieldId() && !editValueOnlyMode()">
                                </div>


                                <div class="form-group row">
                                    <label class="form-label">Type</label>
                                    <div class="form-detail">
                                        <select id="dataTypes" data-bind="options: dataTypes, disable: fieldId() || editValueOnlyMode(), optionsCaption: 'Choose an option', optionsText: 'name', value: selectedDataTypeId, optionsValue: 'id', event: { change: onChangeSpecificationType }"></select>
                                    </div>
                                </div>

                                <div class="form-group auto-list-height"
                                    data-bind="
                                        visible: selectedDataTypeId() == 2 || selectedDataTypeId() == 3,
                                        css: {
                                            'is-disable' : fieldId() || editValueOnlyMode(),
                                            'default-value' : useDefault,
                                        }
                                    "
                                >
                                    ${this.tagPickerSourceFilterTagType.getHtmlBuild()}
                                    <div data-bind="foreach: typeRestrictions()" style="margin-top: -2rem">
                                        <div class="btn-selection">
                                            <span data-bind="text: name"></span>
                                            <button class="icon i-x-after" type="button" data-bind="event: { click: $parent.onClickDeleteRestrictionTypeArray }"></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group"
                                    data-bind="
                                        visible: (selectedDataTypeId() == 1 || selectedDataTypeId() == 6 || selectedDataTypeId() == 7) && idBrand(),
                                        css: { 'default-value' : useDefault }
                                    "
                                >
                                    <label class="form-label">Value</label>
                                    <textarea class="input-text textarea" data-bind="value: value"></textarea>
                                </div>
                                <div class="form-group"
                                    data-bind="
                                        visible: selectedDataTypeId() == 5 && idBrand(),
                                        css: { 'default-value' : useDefault }
                                    "
                                >
                                    <label class="form-label">Value</label>
                                    <textarea id="tagPickerTagTypeFieldTextArea" class="input-text textarea" data-bind="value: value"></textarea>
                                </div>
                                <div class="form-group row"
                                    data-bind="
                                        visible: selectedDataTypeId() == 8 && idBrand(),
                                        css: { 'default-value' : useDefault }
                                    "
                                >
                                    <label class="form-label">Value</label>
                                    <input type="number" name="ratingScale" id="ratingScale" class="input-text" data-bind="value: value, event: { input: function(data, event) { return data.value(data.value().replace(/[^0-9]/g, '')); } }" />
                                </div>

                                <div class="form-group auto-list-height"
                                    data-bind="
                                        visible: (selectedDataTypeId() == 2 || selectedDataTypeId() == 3) && idBrand,
                                        css: { 'default-value' : useDefault }
                                    "
                                >
                                    <div style="display: flex">
                                        <label class="form-label" data-bind="visible: selectedDataTypeId() == 2" style="transform: translateY(-.5rem)">Tag</label>
                                        <label class="form-label" data-bind="visible: selectedDataTypeId() == 3" style="transform: translateY(-.5rem)">Tags</label>
                                        <div class="w-tooltips-adv pos-right short" >
                                              ${ this.editSpecificationTooltip.getHtmlBuild() }
                                        </div>
                                    </div>
                                    ${ this.tagSourcePickerTagFilter.getHtmlBuild() }

                                    <ul data-bind="
                                            foreach: selectedTags,
                                            childrenComplete: handleDragAndDrop($element, selectedTags, '.sortable')
                                            visible: selectedDataTypeId() == 3 || selectedDataTypeId() == 2
                                        "
                                        style="
                                            display: flex;
                                            flex-wrap: wrap;
                                            list-style-type:none;
                                        "
                                    >
                                        <li class="btn-selection d-flex"
                                            data-bind="css: { sortable: ($parent.selectedDataTypeId() == 3) }"
                                            style="
                                                background-color: #f2f2f2;
                                                width:100%;
                                                justify-content: space-between;
                                            "
                                        >
                                            <div class="d-inline-flex" style="gap:0.5rem;">
                                                <span class="icon i-drag" data-bind="visible: $parent.selectedDataTypeId() == 3"></span>
                                                <span data-bind="text: name + (type != null ? ' ' + type  : '')"></span>
                                            </div>
                                            <button data-bind="event: {click: $parent.onClickRemoveSelectedTag }" class="btn-f-s icon i-x-after" type="button"></button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-group row"
                                    data-bind="
                                        visible: selectedDataTypeId() == 4 && idBrand,
                                        css: { 'default-value' : useDefault }
                                    "
                                >
                                    <label class="form-label">Date</label>
                                    <input type="text" class="input-text"  data-bind="value: value " placeholder="YYYY-MM-DD">
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickCancelSaveSpecification }" class="btn ">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickSaveSpecification }, enable: ((selectedDataTypeId() && label() && selectedDataTypeId() != 2 && selectedDataTypeId() != 3) || (typeRestrictions() && typeRestrictions().length > 0) )" class="btn highlight">Apply</button>
                            </div>

                        </div>
                    </div>
                </div>
            `;
    }


    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.tagPickerSourceFilterTagType = new filterAutocomplete_template("tagPickerSourceFilterTagType", this.getTemplateViewModel(), this.caller);
        this.tagPickerSourceFilterTagType.setPlaceholderAndLabel( 'Tag Restriction' );


        this.editSpecificationTooltipContent = `
        <p>All tags are displayed here but only those marked with a green indicator are currently available for use by your brand.</p>
        <ul>
            <li class="is-active">Available for use.</li>
            <li class="is-not-active">Not available for use.</li>
        </ul>
        `
        this.editSpecificationTooltip = new infoButton_template('editSpecificationTooltip', this.getTemplateViewModel(), this.caller)
        this.editSpecificationTooltip.setTitle('Tag Selection');
        this.editSpecificationTooltip.setContent(this.editSpecificationTooltipContent);

        this.tagSourcePickerTagFilter = new filterTag_template("tagSourcePickerTagFilter", this.getTemplateViewModel(), this.caller);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.validationsList.setWidth('100%');
    }


    // implementation of base class [vnTemplate]
    protected getTemplateName(): string {
        return 'tagTypFieldEdit_template';
    }


    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string> {
        return [];
    }

    public setExcludeDataTypesIds(excludeDataTypesIds){
        this.getTemplateViewModel().excludeDataTypesIds(excludeDataTypesIds);
    }

    public getExcludeDataTypesIds(){
        return this.getTemplateViewModel().excludeDataTypesIds();
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel() {

        let self = this;
        return {
            idBrand:ko.observable(null),
            isVisible: ko.observable(false),
            popupTitle: ko.observable('Add new Specification'),
            tagTypeId: ko.observable(null),
            fieldId: ko.observable(null),
            label: ko.observable(''),
            position: ko.observable(null),
            selectedDataTypeId: ko.observable(null),
            selectedDataType: ko.observable(null),
            isForcedOverwrite: ko.observable(null),
            typeRestrictions: ko.observableArray([]),
            value: ko.observable(null),
            isAdded: ko.observable(true),
            disabled: ko.observable(false),
            excludeDataTypesIds: ko.observableArray([]),
            dataTypes: ko.pureComputed( ()=> self.filterDataTypes()),
            selectedTags:ko.observableArray([]),
            groupings: ko.observableArray([]),
            selectedGrouping: ko.observable(null),
            useDefault: ko.observable(false),
            brandOwner: ko.observable(null),
            restrictionTypeArray:ko.observableArray([]),
            isBrandOwner: ko.pureComputed(() => self.isBrandOwner()),
            editValueOnlyMode: ko.observable(false),
            onChangeSpecificationType: function () { self.onChangeSpecificationType(); },
            onClickCancelSaveSpecification: function () { self.onClickCancelSaveSpecification(); },
            onClickSaveSpecification: function () { self.onClickSaveSpecification();},
            onClickRemoveSelectedTag: function (data, event) { self.onClickRemoveSelectedTag(data);},
            onClickDeleteRestrictionTypeArray: function (data, event) { self.onClickDeleteRestrictionTypeArray(data);},
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) { self.handleDragAndDrop(element, currentObservableArray, childrenSelector); },

        };
    }

    protected filterDataTypes() {
        return SPEC_DATA_TYPES.filter((t) => !this.getExcludeDataTypesIds().includes(t.id));
    }

    public getViewModelForRequest(): EditedSpec {

        let value = this.getTemplateViewModel().value();
        let originalValue = this.getTemplateViewModel().value();
        let dataType = this.getTemplateViewModel().selectedDataType();
        let typeRestrictions = [];
        let groupingEdited = this.getTemplateViewModel().groupings()? this.getTemplateViewModel().groupings().find(e => (e.id == this.getTemplateViewModel().selectedGrouping())) : null;

        if (dataType && (dataType.toLowerCase() == 'tags' || dataType.toLowerCase() == 'tag')) {
            originalValue = this.getTemplateViewModel().selectedTags();
            value = '';
            for(let tag of originalValue){
                value += tag.name + ", ";
            }
            typeRestrictions = this.getTemplateViewModel().typeRestrictions().map((r) => r.id);

        }
        if (dataType && (dataType.toLowerCase() == 'rich text')) {
            value = this.caller.getRichTextTagSpecAreaEditor();
        }

        return {
            fieldId: this.getTemplateViewModel().fieldId(),
            label: this.getTemplateViewModel().label(),
            position: this.getTemplateViewModel().position(),
            isDefault: this.getTemplateViewModel().useDefault(),
            dataType: dataType,
            grouping: groupingEdited,
            isForcedOverwrite: this.getTemplateViewModel().isForcedOverwrite(),
            typeRestrictions: typeRestrictions,
            value: value,
            isAdded: this.getTemplateViewModel().isAdded(),
            disabled: this.getTemplateViewModel().disabled(),
            originalValue: originalValue,
            ratingScale: null,
            isProvider: false
        }
    }

    public setBrand(brandId) {
        this.getTemplateViewModel().idBrand(brandId);
    }

    public setBrandOwner(brandOwner: emaki_brand|null): void {
        this.getTemplateViewModel().brandOwner(brandOwner? brandOwner.name : null);
    }

    protected isBrandOwner(): boolean
    {
        return this.getTemplateViewModel().idBrand() &&
            this.getTemplateViewModel().brandOwner() &&
            this.getTemplateViewModel().brandOwner().id &&
            this.getTemplateViewModel().idBrand() === this.getTemplateViewModel().brandOwner().id;
    }

    public setUseDefault(useDefault: boolean): void
    {
        this.getTemplateViewModel().useDefault(useDefault);
    }

    public getFieldDataTypes(): Array<Option> {
        return this.getTemplateViewModel().dataTypes();
    }

    public show() {
        this.getTemplateViewModel().isVisible(true);
    }

    public hide() {
        this.getTemplateViewModel().isVisible(false);
    }


    public addNewTagTypeField(tagTypeId) {
        this.setPopupTitle('Add New Specification');
        this.clearTagTypeFieldData();
        this.setTagTypeId(tagTypeId);
        this.getTemplateViewModel().isVisible(true);
    }

    private getDataTypeByName(name: string): Option {
        let options = this.getFieldDataTypes().filter((fdt) => fdt.name.toLowerCase() == name.toLowerCase());

        if (options.length > 0) {
            return options[0];
        }
        return null;
    }

    private getDataTypeById(id: number): Option {
        let options = this.getFieldDataTypes().filter((fdt) => fdt.id == id);

        if (options.length > 0) {
            return options[0];
        }
        return null;
    }

    public setTagTypeId(tagTypeId) {

        this.getTemplateViewModel().tagTypeId(tagTypeId);
    }

    public setGroupings(groupings){
        this.getTemplateViewModel().groupings(groupings);
    }

    public setTagTypeField(tagTypeField: Spec) {

        let selectedDataTypeId = null;
        let selectedDataType = '';
        if (tagTypeField.label) {

            this.setPopupTitle('Edit (' + tagTypeField.label + ') Specification');
        } else {

            this.setPopupTitle('Add Specification');
        }


        if (tagTypeField.dataType != null) {
            let dataType = this.getDataTypeByName(tagTypeField.dataType);
            selectedDataTypeId = (dataType) ? dataType.id : null;
            selectedDataType = (dataType) ? dataType.name.toLowerCase() : '';
        }

        this.getTemplateViewModel().fieldId(tagTypeField.fieldId);
        this.getTemplateViewModel().label(tagTypeField.label);
        this.getTemplateViewModel().selectedDataTypeId(selectedDataTypeId);
        this.getTemplateViewModel().selectedDataType(selectedDataType);
        this.getTemplateViewModel().isForcedOverwrite(tagTypeField.isForcedOverwrite);
        this.getTemplateViewModel().typeRestrictions(tagTypeField.typeRestrictions);
        this.getTemplateViewModel().isAdded(tagTypeField.isAdded);
        this.getTemplateViewModel().disabled(tagTypeField.disabled);
        this.getTemplateViewModel().useDefault(tagTypeField.isDefault);

        if(tagTypeField.grouping){

            let selectedGroup = this.getTemplateViewModel().groupings().find(c => {
                let group = tagTypeField.grouping.name;
                if (group) {

                    return c.name.toLowerCase() == group.toLowerCase();
                }
            });
            this.getTemplateViewModel().selectedGrouping(selectedGroup.id);
        }

        if(isSpecTypeIdWithRestrictions(selectedDataTypeId)) {

            this.caller.getTagTypes(tagTypeField.typeRestrictions);
            if (tagTypeField.originalValue || (tagTypeField.isDefault && tagTypeField.originalDefaultValue)) {
                const values = tagTypeField.isDefault ? tagTypeField.originalDefaultValue : tagTypeField.originalValue;

                let tagValues = values.map((ov) => {
                    return {
                        id: ov.id,
                        name: ov.name,
                        type: (ov.type != null) ? ov.formattedTagTypeAndDataset: null
                    }
                });
                this.getTemplateViewModel().selectedTags(tagValues);
            }
        } else if (selectedDataTypeId == 5 ) {

            this.caller.setRichTextTagSpecAreaEditor(tagTypeField.isDefault? tagTypeField.defaultValue : tagTypeField.value);
        } else {

            this.getTemplateViewModel().value(tagTypeField.isDefault? tagTypeField.defaultValue : tagTypeField.value);
        }
    }


    public onChangeSpecificationType() {

        let selectedDataTypeId = this.getTemplateViewModel().selectedDataTypeId();
        let dataType = this.getDataTypeById(selectedDataTypeId);
        this.getTemplateViewModel().selectedDataType((dataType) ? dataType.name.toLowerCase() : null);
        // this.getTemplateViewModel().disabled((selectedDataTypeId != 1 && selectedDataTypeId != 6 && selectedDataTypeId != 7));
        if (selectedDataTypeId == 5) {
            let value = this.getTemplateViewModel().value();
            if (value == null) value = '';
            this.caller.setRichTextTagSpecAreaEditor(value);
        }
    }

    private setTagTypesRestriction(typeRestrictions) {

        let newTypeRestrictions = typeRestrictions.map((tr) => {
            return {
                id: tr.id,
                name: `${tr.name} ${tr.formattedDataset}`,
                slug: tr.slug,
                description: tr.description
            };

        });
        this.getTemplateViewModel().typeRestrictions(newTypeRestrictions);
    }

    public clearTagTypeFieldData() {


        this.caller.resetEditedSpec();
        this.getTemplateViewModel().fieldId(null);
        this.getTemplateViewModel().label('');
        this.getTemplateViewModel().selectedGrouping(null);
        this.getTemplateViewModel().selectedDataTypeId(null);
        this.getTemplateViewModel().selectedDataType(null);
        this.getTemplateViewModel().isForcedOverwrite(null);
        this.getTemplateViewModel().typeRestrictions([]);
        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().value(null);
        this.getTemplateViewModel().isAdded(true);
        this.getTemplateViewModel().editValueOnlyMode(false);
    }

    public setPopupTitle(title) {
        this.getTemplateViewModel().popupTitle(title);
    }

    protected onClickCancelSaveSpecification() {

        this.clearTagTypeFieldData();
        this.clearErrorMessages();
        this.hide();
    }
    protected onClickSaveSpecification() {

        let fieldId = this.getTemplateViewModel().fieldId();
        let tagTypeId = this.getTemplateViewModel().tagTypeId();
        let label = this.getTemplateViewModel().label();
        let selectedDataType = this.getTemplateViewModel().selectedDataType();
        let typeRestrictions = this.getTemplateViewModel().typeRestrictions();
        let value = this.getTemplateViewModel().value();
        let idBrand = this.getTemplateViewModel().idBrand();
        this.caller.validateTagSpecFromSource(fieldId, tagTypeId, label, selectedDataType, typeRestrictions, value, idBrand);
    }

    protected onClickRemoveSelectedTag(tag) {

        let selectedTags = this.getTemplateViewModel().selectedTags();
        let filtered = selectedTags.filter((st) => st.id != tag.id);

        this.getTemplateViewModel().selectedTags(filtered);
    }

    protected onClickDeleteRestrictionTypeArray(data) {

        let typeRestrictions = this.getTemplateViewModel().typeRestrictions();
        let filtered = typeRestrictions.filter((tr) => tr.id != data.id );

        this.getTemplateViewModel().typeRestrictions(filtered);

    }

    public setTags(tags) {

        this.getTemplateViewModel().tagSourcePickerTagFilter.tags(tags);
    }

    public addTagTypeRestriction(): void {


        let newTagType = this.tagPickerSourceFilterTagType.getOptionObj();

        this.tagPickerSourceFilterTagType.clearInput();
        let typeRestrictions = this.getTemplateViewModel().typeRestrictions();
        typeRestrictions.push(newTagType);
        this.getTemplateViewModel().typeRestrictions(typeRestrictions);
    }

    public addSelectedTag(): void {

        let selectedDataTypeId = this.getTemplateViewModel().selectedDataTypeId();
        let tagObj = this.tagSourcePickerTagFilter.getTemplateViewModel().tagObj();
        if (!tagObj) {
            this.clearTagFilter();
            return;
        }
        let tag  = {
            id: tagObj.id,
            name: tagObj.name,
            type: tagObj.formattedTagTypeAndDataset
        }
        let value = this.getTemplateViewModel().value();
        if (!value) {
            value = tag.name ;
        } else {
            value = ',' + tag.name;
        }
        this.getTemplateViewModel().value(value);
        let selectedTags = this.getTemplateViewModel().selectedTags();

        let tagInList = selectedTags.filter((t) => t.id == tag.id);

        if (tagInList.length == 0) {
            if (selectedDataTypeId == 2) {
                selectedTags = [tag];
            } else {
                selectedTags.push(tag);
            }
        }
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.clearTagFilter();
    }

    clearTagFilter(): void {
        let tagFilterComponent = document.querySelector('#tagSourcePickerTagFilter');
        let closeBtn = tagFilterComponent.querySelector('#tag-input-close');
        if (closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.remove('is-showing');
            this.tagSourcePickerTagFilter.getTemplateViewModel().idTag(null);
            this.tagSourcePickerTagFilter.getTemplateViewModel().tag("");
            this.tagSourcePickerTagFilter.getTemplateViewModel().tags([]);
            this.tagSourcePickerTagFilter.getTemplateViewModel().tagObj("");
            this.tagSourcePickerTagFilter.getTemplateViewModel().isShowTagSuggestions(false);
        }
    }

    clearErrorMessages(): void {
        this.validationsList.clearMessages();
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }


    public setEditValueOnlyMode(editValueOnlyMode) {
        this.getTemplateViewModel().editValueOnlyMode(editValueOnlyMode);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagTypFieldEdit_template.ts